import type { Optional } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'
import { useMemo } from 'react'
import { useParams } from 'react-router'

import type { AnyConfigurationRouteParams } from '../../system/types'
import { useNavigationParams } from '../../system/useNavigationParams'
import { useApplicationViewOperationsContext } from '../../workspace/applicationViewOperationsContext'

export const useActiveConfigurationPath = () => {
  const translate = useTranslate()
  const {
    enumId,
    templateId,
    registeredTenantId,
    parameterDefinitionId,
    mappingId,
    specId,
  } = useParams<AnyConfigurationRouteParams>()
  const { layer } = useNavigationParams()
  const { applicationTemplates, applicationParameterDefinitions } =
    useApplicationViewOperationsContext()

  let packageName: Optional<string>

  if (templateId) {
    packageName = applicationTemplates.get(templateId)?.lastEntity?.packageName
  } else if (parameterDefinitionId) {
    packageName = applicationParameterDefinitions.get(
      parameterDefinitionId,
    )?.packageName
  } else if (enumId) {
    packageName = translate('enumsTree.fallbackPackage.enums')
  } else if (registeredTenantId) {
    packageName = translate('tenantsTree.fallbackPackage.tenants')
  } else if (mappingId) {
    packageName = translate('glMapsTree.fallbackPackage.glMaps')
  } else if (specId) {
    packageName = translate(
      'reconciliationSpecsTree.fallbackPackage.reconciliationSpecs',
    )
  }

  return useMemo(() => ({ layer, packageName }), [layer, packageName])
}
